/**
 * basic-data-export-requests.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { Message, ReplyVerifyingMessage } from "../general/reply-message";
import { MessageTag } from "../message-tag";

abstract class BasicDataExportRequest extends ReplyVerifyingMessage
{
  /**
   * Construct a new {@link BasicDataExportRequest}.
   */
  constructor (public exportId : number)
  {
    super();
  }
}

// export class DeleteDataExportRequest extends BasicDataExportRequest
// {
//   /** The unique tag for this message type */
//   public tag : MessageTag = MessageTag.REQ_DELETE_AGGREGATOR;
// }

export class PauseDataExportRequest extends BasicDataExportRequest
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.REQ_PAUSE_DATA_EXPORT;
}

export class ResumeDataExportRequest extends BasicDataExportRequest
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.REQ_RESUME_DATA_EXPORT;
}

export class CancelDataExportRequest extends BasicDataExportRequest
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.REQ_CANCEL_DATA_EXPORT;
}

export class DataExportStatusRequest extends BasicDataExportRequest
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.REQ_STATUS_DATA_EXPORT;

  public verifyReply (reply : Message) : boolean
  {
    return Message.isA(reply, MessageTag.RSP_STATUS_DATA_EXPORT);
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/export/basic-data-export-requests.ts